
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destination/[slug]",
      function () {
        return require("private-next-pages/destination/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destination/[slug]"])
      });
    }
  